import VideoServiceDash from 'services/video-service-dash';
import VimeoService from 'services/vimeo-service';
import VideoServiceNative from 'services/video-service-native';
import AsyncBlockService from 'services/async-block-service';
import { KeybindingService, keys } from 'services/keybinding-service';
import IconLoadService from 'services/icon-load-service';

var MultimediaBlockView = require('views/block/multimedia-block-view');
var VideoService = require('services/video-service');
var YouTubeService = require('services/youtube-service');
var CourseSettingsService = require('services/course-settings-service');
var UserAgentService = require('services/user-agent-service');
var LocaleService = require('services/locale-service');
const { Enter, Space, ArrowUp, ArrowDown, ArrowLeft, ArrowRight } = keys;

var VideoView = MultimediaBlockView.extend({
  regions: {
    transcript: '.transcript-modal',
    keyboard_shortcut: '.keyboard_shortcuts-modal',
  },
  services: {
    youtube: function () {
      return new YouTubeService();
    },
    jwplayer: function () {
      return new VideoService();
    },
    dash: function () {
      return window.MediaSource ? new VideoServiceDash(this) : new VideoServiceNative(this);
    },
    vimeo: function () {
      return new VimeoService();
    },
  },
  initialize: function () {
    _.bindAll(this, 'modalShown');
    _.bindAll(this, 'modalHidden');
    var transcript = this.model.get('transcript');
    if (transcript) {
      //close_button_enabled defaults to true if the page doesn't define it
      // need an id to target the modal
      const transcriptDefaults = {
        close_button_enabled: true,
        id: `transcript-${this.model.cid}`,
      };
      _.defaults(transcript, transcriptDefaults);
      if (transcript.dismiss_button) {
        transcript.dismiss_button.class = (transcript.dismiss_button.class || '') + ' continue-button';
      }
      this.model.set('transcript', transcript);
    }

    if (this.model.get('auto_play') === undefined) {
      this.model.set('auto_play', true);
    }

    if (
      CourseSettingsService.get('hideVideosDuringLoad') &&
      !UserAgentService.isIE9() &&
      !UserAgentService.isMobile()
    ) {
      this.model.set('hide', true);
    }
    MultimediaBlockView.prototype.initialize.apply(this, arguments);
    IconLoadService.applyIcon('fas fa-play', this.model.get('cid'), 'fa-lg');
  },
  load: function () {
    var options = {
      height: this.model.get('height'),
      thumbnail_frame: this.model.get('thumbnail_frame') || 2,
      width: this.model.get('width'),
      aspectratio: this.model.get('aspectratio'),
      version: this.model.get('version'),
      container: this.model.get('cid') + '-video-container',
    };
    options = _.defaults(options, this.model.get('options'));

    if (this.model.get('custom_video')) {
      var customization = EF.customizations.getByKeyAndSlug(
        'video-content-customization',
        this.model.get('custom_video')
      );
      if (customization) {
        this.model.set('player', customization.provider);
        this.model.set('video_id', customization.video_id);
        if (customization.video_url) {
          options.metadataUrl = customization.video_url;
          options.customMediaHost = true;
        }
        if (this.model.get('player') === 'metadata') {
          this.model.set('player', CourseSettingsService.get('customVideoPlayer'));
        }
      } else if (!this.model.get('video_id')) {
        return;
      }
    }
    this.service =
      this.services[this.model.get('player') || CourseSettingsService.get('defaultVideoPlayer') || 'jwplayer'].call(
        this
      );
    this.service.initVideo(this.model.get('video_id'), options, this.setupCallbacks());

    this.setupModals();

    if (this.model.get('player') !== 'youtube' && this.model.get('player') !== 'vimeo') {
      this.setupAccessibility();
    }

    if (this.model.get('auto_play')) {
      this.service.on(
        'ready',
        () => {
          this.loaded = true;
          if (this.playCalled) {
            if (window.MediaSource) {
              setTimeout(() => this.togglePlay(), 0);
            }
            this.playCalled = false;
          }
        },
        this
      );
      this.service.on('time', e => {
        if (e.position > 0.2 && this.$el) {
          this.$el.find('.accessibility-wrapper').removeClass('see-through');
        }
      });
    }

    this.subscribeEvent('media:play', assetId => {
      if (assetId !== this.model.get('video_id') && this.service) {
        this.service.pause();
        this.service.stop();
      }
    });

    this.service.on('media:unplayable', e => {
      console.error('Video unplayable:', e.message); //eslint-disable-line no-console
      this.readyToGo();
    });

    Chaplin.mediator.subscribe(`video:play:${this.model.get('video_id')}`, this.togglePlay, this);
    Chaplin.mediator.subscribe(`media:play:${this.model.get('video_id')}`, this.togglePlay, this);
  },
  setupCallbacks() {
    var self = this;
    var callbacks = {
      play: function () {
        $('#startContainer').hide();
        Chaplin.mediator.publish('media:play', self.model.get('video_id'));
        Chaplin.mediator.publish(`media:playing:${self.model.get('video_id')}`);
        Chaplin.mediator.publish(`video:playing:${self.model.get('video_id')}`);
        Chaplin.mediator.publish('media:status:changed', 'playing', self.model.get('video_id'), 'video');
        if (self.pausedAtEnd) {
          self.service.seek(0);
          self.pausedAtEnd = false;
        }
      },
      pause: function () {
        if (self.model) {
          Chaplin.mediator.publish('media:status:changed', 'paused', self.model.get('video_id'), 'video');
        }
      },
      end: function () {
        if (self.model) {
          Chaplin.mediator.publish('media:ended', self.model.get('video_id'));
          Chaplin.mediator.publish(`media:ended:${self.model.get('video_id')}`);
          Chaplin.mediator.publish(`video:ended:${self.model.get('video_id')}`);
          Chaplin.mediator.publish('media:status:changed', 'completed', self.model.get('video_id'), 'video');
          self.readyToGo();
        }
      },
    };

    if (this.model.get('pause_at_end')) {
      this.service.on('time', _e => {
        self.endTime = self.endTime || self.service.getDuration() - 0.5;
        if (self.service.getPosition() > self.endTime) {
          self.service.pause();
          self.pausedAtEnd = true;
          callbacks.end();
        }
      });
    }
    return callbacks;
  },
  setupModals() {
    if (this.model.get('transcript')) {
      const {
        id: transcriptId,
        text: transcriptText,
        header: transcriptHeader,
        dismiss_button: trascriptDismissButton,
        blocks,
      } = this.model.get('transcript');
      let m = new Chaplin.Model({
        type: 'modal',
        id: transcriptId,
        auto_open: false,
        prevent_close_feedback: true,
        blocks: blocks,
        header: transcriptHeader,
        description: transcriptText,
        close_caption: trascriptDismissButton.text,
        button_class: trascriptDismissButton.class,
        sr_close_caption: trascriptDismissButton.text,
        complete_on_shown: true,
      });
      this.setupModal(m, 'transcript');
    }
    if (this.model.get('keyboard_shortcuts')) {
      let m = new Chaplin.Model({
        type: 'modal',
        id: `${this.model.get('video_id')}_keyboard_shortcuts`,
        auto_open: false,
        prevent_close_feedback: true,
        description: 'videoAccessibility.keyboardShortcuts',
        close_caption: 'videoAccessibility.keyboardShortcutsClose',
        button_class: this.model.get('keyboard_shortcuts').dismiss_button_class,
        sr_close_caption: 'videoAccessibility.keyboardShortcutsClose',
      });
      this.setupModal(m, 'keyboard_shortcut');
    }
  },
  setupModal(model, region) {
    AsyncBlockService.load(['modal']).then(([ModalView]) => {
      let modal = new ModalView({
        parent: this,
        region: region,
        model: model,
      });
      this.subview(`${region}-modal`, modal);
      modal.load();
      modal.on('shown', this.modalShown);
      modal.on('hidden', this.modalHidden);
    });
  },
  modalShown() {
    if (!this.model.get('transcript').in_controlbar) {
      this.$el.find('.accessibility-wrapper').addClass('screen-reader-content');
    }
    if (this.service.getState() === 'PLAYING') {
      this.service.pause();
    }
  },
  modalHidden() {
    if (!this.model.get('transcript').in_controlbar) {
      this.$el.find(`.accessibility-wrapper`).removeClass('screen-reader-content');
    }
    this.readyToGo();
  },
  setupAccessibility: function () {
    this.listenTo(this.service, 'ready', this.removePlayerAccessibiltyLinks);
    this.playButton = this.$('[data-action=play]');
    const $startButton = $(`#${this.model.cid}-startButton, #${this.model.cid}-startButton + label`);
    $startButton.on('click', () => {
      this.service.play();
    });
    navigator.mediaSession.setActionHandler('play', () => {
      $startButton.click();
    });
    this.muteButton = this.$('[data-action=mute]');
    this.delegate('click', '[data-action=play]', this.togglePlay);
    this.delegate('click', '[data-action=mute]', this.toggleMute);
    this.delegate('keydown', '.accessibility-wrapper', e => {
      if ($(e.target).hasClass('accessibility-wrapper')) {
        KeybindingService.with(e).bind(
          ['c', 'C'],
          () => {
            this.service.toggleCaptions();
          },
          [Enter, Space],
          () => {
            this.togglePlay();
          },
          ['m', 'M'],
          () => {
            this.toggleMute();
          },
          ArrowUp,
          () => {
            e.preventDefault();
            this.service.increaseVolume(1);
          },
          ArrowDown,
          () => {
            e.preventDefault();
            this.service.decreaseVolume(1);
          },
          ArrowLeft,
          () => {
            e.preventDefault();
            this.service.seek(this.service.getPosition() - 10);
          },
          ArrowRight,
          () => {
            e.preventDefault();
            this.service.seek(this.service.getPosition() + 10);
          }
        );
      }
    });
  },
  removePlayerAccessibiltyLinks: function () {
    // these links generated by jwplayer have no context applied to them for
    // screen readers. We will replace them with our own video controls
    this.$('#beforeswfanchor0').remove();
    this.$('#afterswfanchor0').remove();
  },
  swapAltText: function (el) {
    var text = el.text();
    el.text(el.data('alt-text'));
    el.data('alt-text', text);
  },
  togglePlay: function (e) {
    if (this.model.get('narration')) {
      Chaplin.mediator.publish('media:narration', LocaleService.t(this.model.get('narration')));
    }
    if (this.model.get('disable_actionbar_buttons')) {
      if (this.service.hasCaptions) {
        Chaplin.mediator.publish('button:disabled', 'narration_toggle');
      }
      Chaplin.mediator.publish('button:disabled', 'play_button');
      Chaplin.mediator.publish('button:disabled', 'mute_button');
    }
    switch (this.service.getState().toLowerCase()) {
      case 'idle':
      case 'paused':
        this.service.play();
        if (e && e.target) {
          this.swapAltText($(e.target));
        }
        break;
      case 'playing':
      case 'buffering':
        this.service.pause();
        if (e && e.target) {
          this.swapAltText($(e.target));
        }
        break;
      default:
        break;
    }
  },
  toggleMute: function (e) {
    if (this.service.getMute()) {
      this.service.setMute(false);
    } else {
      this.service.setMute(true);
    }
    if (e && e.target) {
      this.swapAltText($(e.target));
    }
  },
  play: function () {
    var videoMin = this.model.get('completion_override') || CourseSettingsService.get('videoCompletionTime');
    if (this.model.get('custom_video') && !this.model.get('video_id') && !this.model.get('required')) {
      this.readyToGo();
    } else if (this.model.get('required') === false) {
      this.readyToGo();
    } else if (videoMin) {
      setTimeout(_.bind(this.readyToGo, this), parseInt(videoMin));
    }
    if (this.model.get('auto_play')) {
      if (this.loaded) {
        this.togglePlay();
      } else {
        this.playCalled = true;
      }
    }
  },
  pause: function () {
    this.service.pause();
  },
  resume: function () {
    this.togglePlay();
  },
  mute: function () {
    this.service.mute();
    Chaplin.mediator.publish('media:mute:change', 'on');
  },
  unmute: function () {
    this.service.unmute();
    Chaplin.mediator.publish('media:mute:change', 'off');
  },
  replay: function () {
    this.service.play();
  },
  dispose: function () {
    if (this.service) {
      this.service.dispose();
    }
    MultimediaBlockView.prototype.dispose.apply(this, arguments);
  },
});

module.exports = VideoView;
